/* eslint-disable react/jsx-filename-extension */
import React, { useEffect } from 'react';
import './global.css';
import 'rc-slider/assets/index.css';
import { UserProvider } from './hooks/useUser';
import { ContactsProvider } from './hooks/useContacts';
import { NotificationsProvider } from './hooks/useNotifications';
import AppRoutes from './AppRoutes';
import {
  rewardfulDataAttribute,
  rewardfulFunction,
  rewardfulId,
  rewardfulUrl,
} from './constants/rewardful';
import { withSentryReactRouterV6Routing } from '@sentry/react';

function App() {
  const projectId = process.env.FIREBASE_PROJECT_ID;
  const isProduction = projectId === 'new-one-41580';

  // add script for the affiliate program if we are in production
  useEffect(() => {
    if (!isProduction) return;

    const functionScript = document.createElement('script');
    functionScript.text = rewardfulFunction;

    const srcScript = document.createElement('script');

    srcScript.src = rewardfulUrl;
    srcScript.setAttribute(rewardfulDataAttribute, rewardfulId);
    srcScript.async = true;

    document.head.appendChild(functionScript);
    document.head.appendChild(srcScript);

    return () => {
      if (!isProduction) return;
      document.body.removeChild(functionScript);
      document.body.removeChild(srcScript);
    };
  }, []);

  const SentryRoutes = withSentryReactRouterV6Routing(AppRoutes);

  return (
    <UserProvider>
      <NotificationsProvider>
        <ContactsProvider>
          <SentryRoutes />
        </ContactsProvider>
      </NotificationsProvider>
    </UserProvider>
  );
}

export default App;
